@if (loading) {
  <kor-spinner label="Finalizando registro"></kor-spinner>
} @else {
  <form
    [formGroup]="registrationForm"
    (ngSubmit)="onSubmit()"
    class="flex flex-col gap-2 flex-1"
  >
    <div class="flex-1 flex flex-col gap-2 justify-center">
      <p class="mb-2">Forneça seus dados para continuar.</p>
      <!-- inputs -->
      <input
        id="email"
        formControlName="email"
        type="email"
        placeholder="Email"
        required
        autocomplete="email"
      />
      <input
        id="password"
        formControlName="password"
        type="password"
        placeholder="Senha"
        required
        autocomplete="new-password"
      />
      <input
        id="orgName"
        formControlName="orgName"
        type="text"
        placeholder="Nome da empresa"
        required
        autocomplete="organization"
      />
      <input
        id="phoneNumber"
        formControlName="phoneNumber"
        type="tel"
        placeholder="Telefone"
        required
        autocomplete="tel"
        maxlength="11"
        pattern="[0-9]*"
        inputmode="numeric"
      />

      @if ((authService.loginError | async)?.length) {
        <p
          [innerHTML]="authService.loginError | async"
          class="text-red-600 leading-snug"
        ></p>
      }
    </div>

    <!-- cta -->
    <button
      type="submit"
      class="mt-auto w-full max-w-none box-border"
      [disabled]="!registrationForm.valid"
    >
      Registrar
    </button>
    <hr class="m-1" />
    <button
      class="secondary gap-2 !bg-accent-950 hover:!bg-accent-900 !text-white"
      (click)="sharedAuthService.handleGoogleSignIn()"
    >
      <img height="16" width="16" src="assets/icons/google-logo.png" />
      Entrar com Google
    </button>
  </form>
}
